<template>
  <div class="list-element">
    <div class="element-header">
      <span class="element-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
        <span>Liste interactive WhatsApp</span>
      </span>
      <div class="element-actions">
        <button 
          class="action-btn mode-btn" 
          @click.stop="toggleMode" 
          :title="mode === 'visual' ? 'Passer en mode JSON' : 'Passer en mode Visuel'"
          :class="{ 'active': mode === 'json' }"
        >
          <svg v-if="mode === 'visual'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
        </button>
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="list-content">
      <!-- JSON Mode -->
      <div v-if="mode === 'json'" class="json-mode-container">
        <div class="json-editor-header">
          <span class="info-text">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px; vertical-align: middle;">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            Éditez directement la configuration JSON. Attention à la syntaxe.
          </span>
          <button class="save-json-btn" @click="saveJsonChanges" :disabled="!!jsonError">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px;">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg> Appliquer
          </button>
        </div>
        <div class="json-editor-wrapper">
          <textarea 
            v-model="jsonContent" 
            class="json-textarea" 
            spellcheck="false"
            @input="checkJsonSyntax"
            placeholder="{ ... }"
          ></textarea>
          <div v-if="jsonError" class="json-error-message">
            {{ jsonError }}
          </div>
        </div>
      </div>

      <!-- Visual Mode -->
      <div v-else>
        <!-- Header Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M6 4v16"></path>
            <path d="M18 4v16"></path>
            <path d="M6 12h12"></path>
          </svg>
          En-tête (optionnel)
        </h4>
        <div class="config-field">
          <label>Texte de l'en-tête:</label>
          <input 
            v-model="localElement.interactive.header.text" 
            @blur="updateElement"
            type="text" 
            placeholder="Titre de votre liste (max 60 caractères)"
            maxlength="60"
            class="config-input"
          />
          <small class="field-info">{{ (localElement.interactive.header.text || '').length }}/60 caractères</small>
        </div>
      </div>

      <!-- Body Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="17" y1="10" x2="3" y2="10"></line>
            <line x1="21" y1="6" x2="3" y2="6"></line>
            <line x1="21" y1="14" x2="3" y2="14"></line>
            <line x1="17" y1="18" x2="3" y2="18"></line>
          </svg>
          Corps du message (obligatoire)
        </h4>
        <div class="config-field">
          <label>Texte du corps:</label>
          <textarea 
            v-model="localElement.interactive.body.text" 
            @blur="updateElement"
            placeholder="Description de votre liste (max 4096 caractères)"
            maxlength="4096"
            rows="3"
            class="config-textarea"
          ></textarea>
          <small class="field-info">{{ (localElement.interactive.body.text || '').length }}/4096 caractères</small>
        </div>
      </div>

      <!-- Footer Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="4 7 4 4 20 4 20 7"></polyline>
            <line x1="9" y1="20" x2="15" y2="20"></line>
            <line x1="12" y1="4" x2="12" y2="20"></line>
          </svg>
          Pied de page (optionnel)
        </h4>
        <div class="config-field">
          <label>Texte du pied de page:</label>
          <input 
            v-model="localElement.interactive.footer.text" 
            @blur="updateElement"
            type="text" 
            placeholder="Signature ou info supplémentaire (max 60 caractères)"
            maxlength="60"
            class="config-input"
          />
          <small class="field-info">{{ (localElement.interactive.footer.text || '').length }}/60 caractères</small>
        </div>
      </div>

      <!-- Button Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          Bouton d'action (obligatoire)
        </h4>
        <div class="config-field">
          <label>Texte du bouton:</label>
          <input 
            v-model="localElement.interactive.action.button" 
            @blur="updateElement"
            type="text" 
            placeholder="Libellé du bouton (max 20 caractères)"
            maxlength="20"
            class="config-input"
          />
          <small class="field-info">{{ (localElement.interactive.action.button || '').length }}/20 caractères</small>
        </div>
      </div>

      <!-- Variable Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
          Sauvegarder le choix dans une variable
        </h4>
        <div class="config-field">
          <label>Variable :</label>
          <select 
            v-model="localVariableId"
            @change="updateVariable"
            class="config-input config-select"
          >
            <option value="">Ne pas sauvegarder le choix</option>
            <option 
              v-for="variable in variables" 
              :key="variable.id" 
              :value="variable.id"
            >
              {{variable.id}}
            </option>
          </select>
          <small class="field-info">Sélectionnez la variable dans laquelle stocker le choix de l'utilisateur.</small>
        </div>
      </div>
          
      <!-- Sections Configuration -->
      <div class="list-config-section" v-if="localElement && localElement.interactive">
        <h4 class="config-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
            <polyline points="2 17 12 22 22 17"></polyline>
            <polyline points="2 12 12 17 22 12"></polyline>
          </svg>
          Sections (max 10 sections, max 10 éléments au total)
        </h4>
        
        <div v-if="localElement.interactive.action.sections && localElement.interactive.action.sections.length > 0" class="sections-container">
          <div v-for="(section, secIndex) in localElement.interactive.action.sections" :key="secIndex" class="section-item">
            <div class="section-header">
              <div class="section-info">
                <strong>Section {{ secIndex + 1 }}: {{ section.title || 'Sans titre' }}</strong>
                <small>({{ section.rows ? section.rows.length : 0 }} éléments)</small>
              </div>
              <div class="section-actions">
                <button class="section-btn edit" @click="editSection(secIndex)" title="Modifier">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button class="section-btn delete" @click="removeSection(secIndex)" title="Supprimer">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
            
            <!-- Section Editing Panel -->
            <div v-if="editingSectionIndex === secIndex" class="section-edit-panel">
              <div class="edit-field">
                <label>Titre de la section:</label>
                <input 
                  v-model="section.title"
                  @blur="updateElement"
                  type="text" 
                  placeholder="Titre de la section (max 24 caractères)"
                  maxlength="24"
                  class="config-input"
                />
                <small class="field-info">{{ (section.title || '').length }}/24 caractères</small>
              </div>
              
              <!-- Rows in this section -->
              <div class="rows-container">
                <h5>Éléments de la section:</h5>
                <div v-if="section.rows && section.rows.length > 0" class="rows-list">
                  <div v-for="(row, rowIndex) in section.rows" :key="rowIndex" class="row-item">
                    <div class="row-header">
                      <span class="row-title">{{ row.title || 'Sans titre' }}</span>
                      <div class="row-actions">
                        <button class="row-btn edit" @click="editRow(secIndex, rowIndex)" title="Modifier">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                          </svg>
                        </button>
                        <button class="row-btn delete" @click="removeRow(secIndex, rowIndex)" title="Supprimer">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                    
                    <!-- Row Editing -->
                    <div v-if="editingRowIndex === `${secIndex}-${rowIndex}`" class="row-edit-panel">
                      <div class="edit-field autocomplete-field">
                        <label>ID de l'élément:</label>
                        <div class="autocomplete-container">
                          <BlockSelector
                            :value="row.id"
                            :idBot="idBot"
                            :allowCustom="true"
                            placeholder="Identifiant unique ou bloc"
                            @blocks-loaded="availableBlocks = $event"
                            @change="updateElement"
                            @input="row.id = $event; updateElement()"
                          />
                        </div>
                        <small class="field-info">{{ (row.id || '').length }}/200 caractères</small>
                      </div>
                      
                      <div class="edit-field autocomplete-field">
                        <label>Titre de l'élément:</label>
                        <div class="autocomplete-container">
                          <input 
                            v-model="row.title"
                            @input="onTitleInput(row, $event)"
                            @focus="showTitleSuggestionsFor(`${secIndex}-${rowIndex}`)"
                            @blur="onTitleBlur"
                            type="text" 
                            placeholder="Titre de l'élément (max 24 caractères)"
                            maxlength="24"
                            class="config-input"
                          />
                          <div 
                            v-if="showTitleSuggestions && currentEditingRowKey === `${secIndex}-${rowIndex}`" 
                            class="suggestions-dropdown"
                          >
                            <div class="suggestions-header">Titres existants:</div>
                            <div 
                              v-for="suggestion in titleSuggestions" 
                              :key="suggestion.idblock"
                              @mousedown="selectTitleSuggestion(row, suggestion.displayName)"
                              class="suggestion-item"
                            >
                              <div class="suggestion-title">{{ suggestion.displayName }}</div>
                              <div class="suggestion-id">{{ suggestion.idblock }}</div>
                            </div>
                            <div v-if="titleSuggestions.length === 0" class="no-suggestions">
                              Aucun titre trouvé
                            </div>
                          </div>
                        </div>
                        <small class="field-info">{{ (row.title || '').length }}/24 caractères</small>
                      </div>
                      
                      <div class="edit-field">
                        <label>Description:</label>
                        <input 
                          v-model="row.description"
                          @blur="updateElement"
                          type="text" 
                          placeholder="Description optionnelle (max 72 caractères)"
                          maxlength="72"
                          class="config-input"
                        />
                        <small class="field-info">{{ (row.description || '').length }}/72 caractères</small>
                      </div>
                      
                      <button class="save-btn" @click="stopEditingRow">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px;">
                          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                          <polyline points="17 21 17 13 7 13 7 21"></polyline>
                          <polyline points="7 3 7 8 15 8"></polyline>
                        </svg>
                        Sauvegarder
                      </button>
                    </div>
                  </div>
                </div>
                
                <button 
                  class="add-row-btn" 
                  @click="addRow(secIndex)"
                  :disabled="getTotalRowsCount() >= 10"
                  title="Ajouter un élément à cette section"
                >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px;">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
                  Ajouter un élément
                </button>
              </div>
              
              <button class="save-btn" @click="stopEditingSection">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px;">
                  <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                  <polyline points="17 21 17 13 7 13 7 21"></polyline>
                  <polyline points="7 3 7 8 15 8"></polyline>
                </svg>
                Fermer l'édition
            </button>
          </div>
        </div>
      </div>
      
        <button 
          class="add-section-btn" 
          @click="addSection"
          :disabled="localElement.interactive.action.sections.length >= 10"
          title="Ajouter une nouvelle section"
        >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 4px;">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="16"></line>
          <line x1="8" y1="12" x2="16" y2="12"></line>
        </svg>
          Ajouter une section
      </button>
        
        <div class="section-limits" v-if="localElement && localElement.interactive">
          <small>
            Sections: {{ localElement.interactive.action.sections.length }}/10 | 
            Éléments totaux: {{ getTotalRowsCount() }}/10
          </small>
        </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosPeelo } from '@/utils/axios';
import { consoleError } from '@/utils/logger';
import BlockSelector from '@/components/common/BlockSelector.vue';

export default {
  name: 'ListElement',
  components: {
    BlockSelector
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    idBot: {
      type: String,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      editingSectionIndex: null,
      editingRowIndex: null,
      showTitleSuggestions: false,
      titleSuggestions: [],
      currentEditingRowKey: null,
      availableBlocks: [],
      isLoading: false,
      mode: 'visual', // 'visual' | 'json'
      jsonContent: '',
      jsonError: null,
      localElement: null,
      localVariableId: '',
      _lastSelfUpdateTime: 0 // Timestamp-based guard for self-emitted updates
    }
  },
  watch: {
    element: {
      handler(newVal) {
        // Guard: skip reinit for 500ms after a self-emitted update
        // refreshChain in the parent triggers multiple prop changes (map + save),
        // so a simple boolean flag gets consumed too early.
        if (Date.now() - this._lastSelfUpdateTime < 500) {
          return;
        }
        // Guard: never reinit while the user is actively editing a section or row
        if (this.editingSectionIndex !== null || this.editingRowIndex !== null) {
          return;
        }
        if (!this.localElement || JSON.stringify(newVal) !== JSON.stringify(this.localElement)) {
          this.initLocalElement();
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    this.initLocalElement();
  },
  methods: {
    initLocalElement() {
      const copy = JSON.parse(JSON.stringify(this.element));
      // Normalise la structure `interactive` : garantit header/body/footer/action/sections.
      // Les listes générées par Moo (ou importées) peuvent omettre `footer` (ou header/body) ;
      // sans cette normalisation, le template accède à `interactive.footer.text` sur undefined
      // → crash au rendu → le bloc paraît VIDE. On comble les champs manquants sans écraser l'existant.
      const it = (copy.interactive && typeof copy.interactive === 'object') ? copy.interactive : {};
      it.type = it.type || 'list';
      if (!it.header || typeof it.header !== 'object') it.header = { type: 'text', text: '' };
      if (it.header.text == null) it.header.text = '';
      if (!it.body || typeof it.body !== 'object') it.body = { text: '' };
      if (it.body.text == null) it.body.text = '';
      if (!it.footer || typeof it.footer !== 'object') it.footer = { text: '' };
      if (it.footer.text == null) it.footer.text = '';
      if (!it.action || typeof it.action !== 'object') it.action = { button: '', sections: [] };
      if (it.action.button == null) it.action.button = '';
      if (!Array.isArray(it.action.sections)) it.action.sections = [];
      copy.interactive = it;
      this.localElement = copy;
      this.localVariableId = copy.options?.variable?.id || '';
    },
    updateVariable(event) {
      const variableId = event.target.value;
      if (!this.localElement.options) {
        this.localElement.options = {};
      }
      
      if (variableId) {
        this.localElement.options.variable = { id: variableId };
      } else {
        if (this.localElement.options.variable) {
          delete this.localElement.options.variable;
        }
      }
      
      this.updateElement();
    },
    
    updateElement() {
      // Set timestamp so the watcher ignores prop changes from this save cycle
      this._lastSelfUpdateTime = Date.now();
      this.$emit('update', JSON.parse(JSON.stringify(this.localElement)));
    },
    
    getTotalRowsCount() {
      if (!this.localElement?.interactive?.action?.sections) return 0;
      return this.localElement.interactive.action.sections.reduce((total, section) => {
        return total + (section.rows ? section.rows.length : 0);
      }, 0);
    },
    
    addSection() {
      if (!this.localElement.interactive.action.sections) {
        this.localElement.interactive.action.sections = [];
      }
      if (this.localElement.interactive.action.sections.length >= 10) return;
      
      const newSection = {
        title: `Section ${this.localElement.interactive.action.sections.length + 1}`,
        rows: []
      };
      
      this.localElement.interactive.action.sections.push(newSection);
      // Don't emit here — let the user edit first, emit on explicit save/blur
    },
    
    removeSection(index) {
      if (confirm('Êtes-vous sûr de vouloir supprimer cette section ?')) {
        this.localElement.interactive.action.sections.splice(index, 1);
        if (this.editingSectionIndex === index) {
          this.editingSectionIndex = null;
        }
        this.editingRowIndex = null;
        // Emit after structural change so parent stays in sync
        this.updateElement();
      }
    },
    
    editSection(index) {
      this.editingSectionIndex = this.editingSectionIndex === index ? null : index;
      this.editingRowIndex = null;
    },
    
    stopEditingSection() {
      this.editingSectionIndex = null;
      this.editingRowIndex = null;
      this.updateElement();
    },
    
    addRow(sectionIndex) {
      if (this.getTotalRowsCount() >= 10) return;
      
      const newRow = {
        id: `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        title: '',
        description: ''
      };
      
      if (!this.localElement.interactive.action.sections[sectionIndex].rows) {
        this.localElement.interactive.action.sections[sectionIndex].rows = [];
      }
      this.localElement.interactive.action.sections[sectionIndex].rows.push(newRow);
      // Don't emit here — let the user fill out the row first
      
      // Automatically start editing the new row
      this.editRow(sectionIndex, this.localElement.interactive.action.sections[sectionIndex].rows.length - 1);
    },
    
    removeRow(sectionIndex, rowIndex) {
      if (confirm('Êtes-vous sûr de vouloir supprimer cet élément ?')) {
        this.localElement.interactive.action.sections[sectionIndex].rows.splice(rowIndex, 1);
        this.editingRowIndex = null;
        // Emit after structural deletion so parent stays in sync
        this.updateElement();
      }
    },
    
    editRow(sectionIndex, rowIndex) {
      const rowKey = `${sectionIndex}-${rowIndex}`;
      this.editingRowIndex = this.editingRowIndex === rowKey ? null : rowKey;
    },
    
    stopEditingRow() {
      this.editingRowIndex = null;
      this.hideAllSuggestions();
      this.updateElement();
    },
    
    // Autocomplétion pour titre
    onTitleInput(row, event) {
      const value = event.target.value;
      row.title = value;
      this.filterTitleSuggestions(value);
      // Ne pas sauvegarder automatiquement pendant la saisie
    },
    
    showTitleSuggestionsFor(rowKey) {
      this.currentEditingRowKey = rowKey;
      this.showTitleSuggestions = true;
      this.filterTitleSuggestions('');
    },
    
    onTitleBlur() {
      // Sauvegarder quand l'utilisateur sort du champ + fermer suggestions
      setTimeout(() => {
        this.showTitleSuggestions = false;
        this.updateElement();
      }, 200);
    },
    
    filterTitleSuggestions(searchTerm) {
      if (!this.availableBlocks || this.availableBlocks.length === 0) {
        this.titleSuggestions = [];
        return;
      }
      
      const term = searchTerm.toLowerCase();
      this.titleSuggestions = this.availableBlocks.filter(block => {
        const blockName = (block.displayName || block.blockname || '').toLowerCase();
        const blockId = (block.idblock || '').toLowerCase();
        return blockName.includes(term) || blockId.includes(term);
      }).slice(0, 10); // Limiter à 10 suggestions
    },
    
    selectTitleSuggestion(row, selectedTitle) {
      // Tronquer le titre si nécessaire pour respecter la limite de 24 caractères
      row.title = selectedTitle.length > 24 ? selectedTitle.substring(0, 24) : selectedTitle;
      this.showTitleSuggestions = false;
      this.updateElement();
    },
    
    hideAllSuggestions() {
      this.showTitleSuggestions = false;
      this.currentEditingRowKey = null;
    },
    
    toggleMode() {
      if (this.mode === 'visual') {
        // Switch to JSON
        this.jsonContent = JSON.stringify(this.element.interactive || {}, null, 2);
        this.mode = 'json';
        this.jsonError = null;
      } else {
        // Switch to Visual
        if (this.saveJsonChanges()) {
          this.mode = 'visual';
        }
      }
    },
    
    checkJsonSyntax() {
      try {
        JSON.parse(this.jsonContent);
        this.jsonError = null;
      } catch (e) {
        this.jsonError = e.message;
      }
    },
    
    saveJsonChanges() {
      try {
        const parsed = JSON.parse(this.jsonContent);
        
        // Basic validation structure could go here if needed
        
        // Update local state directly to ensure visual mode reflects changes immediately
        // (Similar to how updateInteractiveFieldSilent works for inputs)
        
        // SMART HANDLING: Check if user pasted the full element (which has an 'interactive' property)
        // or just the interactive payload itself.
        if (parsed.interactive && typeof parsed.interactive === 'object' && !parsed.header && !parsed.action) {
           // User likely pasted the full element JSON. We extract only the interactive part.
           this.element.interactive = parsed.interactive;
        } else {
           // User pasted just the interactive payload (standard behavior)
           this.element.interactive = parsed;
        }
        
        // Emit the update to the parent
        this.$emit('update', this.element);
        
        this.jsonError = null;
        return true;
      } catch (e) {
        this.jsonError = "Erreur de syntaxe JSON : " + e.message;
        return false;
      }
    }
  },
  
  mounted() {
    // Initialization is handled by initLocalElement() via the watcher
  }
}
</script>

<style scoped>
.list-element {
  background: #ffffff;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 10px 25px rgba(20, 48, 40, 0.08);
  border: 1px solid rgba(20, 48, 40, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  max-width: 100%;
}

.list-element:hover {
  box-shadow: 0 15px 35px rgba(20, 48, 40, 0.12);
  border-color: rgba(218, 255, 209, 0.5);
  transform: translateY(-2px);
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: #143028; /* Peelo Dark Green */
  border-bottom: 1px solid rgba(218, 255, 209, 0.1);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.element-type-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #daffd1; /* Peelo Mint */
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.element-type-badge svg {
  color: #daffd1;
}

.element-actions {
  display: flex;
  gap: 10px;
}

.action-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(218, 255, 209, 0.15);
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(218, 255, 209, 0.7);
  transition: all 0.25s ease;
}

.action-btn:hover {
  background: rgba(218, 255, 209, 0.1);
  color: #daffd1;
  border-color: #daffd1;
  transform: scale(1.05);
}

.action-btn.delete-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.list-content {
  padding: 1rem;
  max-height: 600px;
  overflow-y: auto;
}

/* Configuration Sections */
.list-config-section {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.config-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: #143028; /* Peelo Dark Green */
}

.config-title svg {
  color: #143028; /* Changed to Peelo Green */
}

.config-field {
  margin-bottom: 0.75rem;
}

.config-field:last-child {
  margin-bottom: 0;
}

.config-field label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
}

/* JSON Mode Styles */
.json-mode-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.json-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.info-text {
  font-size: 0.8rem;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
}

.save-json-btn {
  background: #ea580c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background 0.2s;
}

.save-json-btn:hover {
  background: #c2410c;
}

.save-json-btn:disabled {
  background: #fed7aa;
  cursor: not-allowed;
}

.json-editor-wrapper {
  position: relative;
  flex: 1;
}

.json-textarea {
  width: 100%;
  min-height: 400px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 13px;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background-color: #f9fafb;
  color: #1f2937;
  resize: vertical;
  line-height: 1.5;
}

.json-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1);
}

.json-error-message {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background: #fee2e2;
  color: #b91c1c;
  padding: 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  border: 1px solid #fecaca;
  pointer-events: none;
}

.mode-btn {
  color: #4b5563;
}

.mode-btn.active {
  background: rgba(218, 255, 209, 0.2);
  color: #daffd1;
}

.config-input, .config-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
  color: #1a202c; /* Ensure text is dark */
  background-color: #ffffff; /* Ensure background is white */
}

.config-input:focus, .config-textarea:focus {
  outline: none;
  border-color: #143028; /* Peelo Dark Green */
  box-shadow: 0 0 0 2px rgba(20, 48, 40, 0.1);
}

.config-textarea {
  resize: vertical;
  min-height: 60px;
}

.field-info {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #6b7280;
}

/* Sections Management */
.sections-container {
  margin-top: 1rem;
}

.section-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.section-header:hover {
  background: #e5e7eb;
}

.section-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.section-info strong {
  color: #374151;
}

.section-info small {
  color: #6b7280;
  font-size: 0.8rem;
}

.section-actions {
  display: flex;
  gap: 0.5rem;
}

.section-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #6b7280;
  width: 32px;
  height: 32px;
}

.section-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.section-btn.delete:hover {
  background: #fee2e2;
  color: #ef4444;
}

/* Section Edit Panel */
.section-edit-panel {
  padding: 1rem;
  background: white;
  border-top: 1px solid #e5e7eb;
}

.edit-field {
  margin-bottom: 1rem;
}

.edit-field label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151; /* Dark gray for labels */
}

.edit-field:last-child {
  margin-bottom: 0;
}

/* Rows Management */
.rows-container {
  margin-top: 1rem;
}

.rows-container h5 {
  margin: 0 0 0.75rem 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
}

.rows-list {
  margin-bottom: 1rem;
}

.row-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  overflow: hidden;
}

.row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.row-header:hover {
  background: #f3f4f6;
}

.row-title {
  font-weight: 500;
  color: #374151;
}

.row-actions {
  display: flex;
  gap: 0.25rem;
}

.row-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: #6b7280;
  width: 24px;
  height: 24px;
}

.row-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

.row-btn.delete:hover {
  background: #fee2e2;
  color: #ef4444;
}

/* Row Edit Panel */
.row-edit-panel {
  padding: 0.75rem;
  background: white;
  border-top: 1px solid #e5e7eb;
}

/* Buttons */
.add-row-btn, .add-section-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  font-weight: 500;
}

.add-row-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}

.add-row-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-section-btn {
  border-color: #143028; /* Peelo Dark Green */
  color: #143028;
  margin-top: 1rem;
}

.add-section-btn:hover {
  background: rgba(218, 255, 209, 0.2); /* Light Mint */
  border-color: #143028;
  color: #143028;
}

.add-section-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.save-btn {
  background: #143028; /* Peelo Dark Green */
  color: #daffd1; /* Peelo Mint */
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.save-btn:hover {
  background: #0f241d;
}

.section-limits {
  margin-top: 1rem;
  padding: 0.5rem;
  background: #fef3e2;
  border-radius: 6px;
  text-align: center;
}

.section-limits small {
  color: #c2410c;
  font-weight: 500;
}

/* Autocomplétion */
.autocomplete-field {
  position: relative;
}

.autocomplete-container {
  position: relative;
}

.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d1d5db;
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.suggestions-header {
  padding: 0.5rem 0.75rem;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6b7280;
}

.suggestion-item {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;
}

.suggestion-item:hover {
  background: #f3f4f6;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-id {
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.1rem;
}

.suggestion-name, .suggestion-title {
  font-size: 0.75rem;
  color: #6b7280;
}

.no-suggestions {
  padding: 0.75rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.8rem;
  font-style: italic;
}
</style>
